export default __webpack_public_path__ + "static/media/item_1_active.885c9d33.png";